import { makeObservable, computed, reaction } from 'mobx';
import { LayersNodeModel, ComparisonNodeBaseModel } from '..';
import { ContractComparisonPanel } from '../../types';

export default class LayersComparisonNodeModel extends ComparisonNodeBaseModel {
    constructor(
        nodeId: string,
        nodeName: string,
        readonly layerId: string,
        predefinedPanels?: ContractComparisonPanel[],
        readonly newNode?: LayersNodeModel,
        readonly previousNode?: LayersNodeModel
    ) {
        super(nodeId, nodeName, predefinedPanels);

        makeObservable(this, {
            inputIds: computed,
            newLayer: computed,
            previousLayer: computed
        });

        this.initializeChangeTrackers();

        this.reactions.push(
            reaction(
                () => this.inputIds,
                () => this.initializeChangeTrackers()
            )
        );
    }

    initializeChangeTrackers() {
        this.contractChangeTracker.clearInputGroupChangeTrackers();

        this.panels.forEach(panel => {
            const inputGroupChangeTracker = this.contractChangeTracker.createInputGroupChangeTracker(
                panel.id,
                panel.name
            );

            panel.inputIds.forEach(inputId => {
                inputGroupChangeTracker.createInputChangeTracker(
                    inputId,
                    this.newLayer?.getInputById(inputId),
                    this.previousLayer?.getInputById(inputId)
                );
            });
        });
    }

    get newLayer() {
        return this.newNode?.layers.find(layer => layer.id === this.layerId);
    }

    get previousLayer() {
        return this.previousNode?.layers.find(layer => layer.id === this.layerId);
    }

    get inputIds() {
        return this.getInputIds(
            this.newLayer?.inputs.map(input => input.id),
            this.previousLayer?.inputs.map(input => input.id)
        );
    }
}
